import { render, staticRenderFns } from "./FileUploadConfig.vue?vue&type=template&id=08ea7fcc&scoped=true&"
import script from "./FileUploadConfig.vue?vue&type=script&lang=js&"
export * from "./FileUploadConfig.vue?vue&type=script&lang=js&"
import style0 from "./FileUploadConfig.vue?vue&type=style&index=0&id=08ea7fcc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ea7fcc",
  null
  
)

export default component.exports